<template>
  <div class="ticket-manage">
    <div class="manage-query">
      <el-form
        :inline="true"
        :model="query"
        ref="queryForm"
        size="small"
        class="query-middle"
      >
        <el-form-item label="行程单编号：">
          <el-input v-model="query.Code"></el-input>
        </el-form-item>
        <el-form-item label="行程时间：" style="margin-left:20px;">
          <el-date-picker
            v-model="query.StartTime"
            type="date"
            style="width: 200px"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="—">
          <el-date-picker
            v-model="query.EndTime"
            type="date"
            style="width: 200px"
           format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left:20px;">
          <el-button type="primary" icon="el-icon-search" @click="getTickets"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button
            type="info"
            icon="el-icon-circle-close"
            @click="resetForm('queryForm')"
            >清除</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="manage-content">
      <div class="main-left">
        <div class="main-title">
          <span> <i class="el-icon-folder-opened"></i> 行程单列表 </span>
          <el-button-group>
            <router-link to="/ticket-input">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-circle-plus-outline"
                >新增</el-button
              >
            </router-link>
          </el-button-group>
        </div>
        <div class="left-table">
          <el-table :data="tableData" height="753px" border style="width: 100%" v-loading="loadintTable">
            <el-table-column
              type="selection"
              min-width="10"
              align="center"
            ></el-table-column>
            <el-table-column
              label="行程单编号"
              prop="Code"
              min-width="200"
              align="center"
            ></el-table-column>
            <el-table-column
              label="线路名称"
              prop="Name"
              min-width="180"
              align="center"
            ></el-table-column>
            <el-table-column
              label="开始时间"
              prop="StartTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.StartTime | dateFormatTemp }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="结束时间"
              prop="EndTime"
              min-width="140"
              align="center"
            >
              <template slot-scope="scope">
                <p>{{ scope.row.EndTime | dateFormatTemp }}</p>
              </template>
            </el-table-column>
            <el-table-column
              label="人数"
              prop="TouristCount"
              min-width="60"
              align="center"
            ></el-table-column>
            <el-table-column
              label="状态"
              prop="Status"
              min-width="80"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-tag
                  :type="scope.row.Status | keyToVal(statusType)"
                  effect="dark"
                  size="small"
                  >{{ scope.row.Status | keyToVal(ticketStatus) }}</el-tag
                >
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              min-width="120"
              align="center"
              fixed="right"
            >
              <template slot-scope="scope">
                <el-row type="flex" class="row-bg" justify="space-between">
                  <el-button
                    size="mini"
                    type="primary"
                    v-on:click="getDetail(scope.row)"
                    >查看</el-button
                  >
                </el-row>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="left-pagination">
          <el-pagination
            class="pagination-bottom"
            background
            layout="prev, pager, next, total,sizes,jumper"
            :total="pagination.total"
            :page-size="pagination.PageSize"
            :page-sizes="[10, 20, 50]"
            :current-page.sync="pagination.PageIndex"
            v-on:size-change="handlePageSize"
            v-on:current-change="handlePageIndex"
          ></el-pagination>
        </div>
      </div>
      <div class="main-right">
        <div class="main-title">
          <span> <i class="el-icon-document"></i> 查看 </span>
        </div>
        <div class="right-table">
          <table class="input-form" v-if="flag===1" v-loading="loadingLook">
            <thead>
              <th colspan="7">电子行程单（查看）</th>
            </thead>
            <tbody>
              <tr style="height: 41px">
                <td>行程编号</td>
                <td colspan="2">{{ detail.Code }}</td>
                <td>行程描述</td>
                <td colspan="3"><el-input v-model="detail.Remarks" readonly ></el-input></td>
              </tr>
              <tr style="height: 41px">
                <td>行程名称</td>
                <td>{{ detail.Name }}</td>
                <td>组团旅行社</td>
                <td>{{ detail.CompanyName }}</td>
                <td>行程时间</td>
                <td colspan="2">
                  {{ detail.StartTime + " 至 " + detail.EndTime }}
                </td>
              </tr>
              <tr style="height: 41px">
                <td>行程人数</td>
                <td>{{ detail.TouristCount }}</td>
                <td>行程起点</td>
                <td><el-input v-model="detail.StartPoint" readonly></el-input></td>
                <td>行程终点</td>
                <td colspan="2"><el-input v-model="detail.EndPoint" readonly ></el-input></td>
              </tr>
              <tr>
                <td colspan="7" class="emphasis">行程安排</td>
              </tr>
              <tr style="height: 45px">
                <td colspan="7"></td>
              </tr>
              <div class="subtable-tab">
                <div
                  v-for="(item, index) in table"
                  :key="index"
                  class="mouse-pointer tab-item"
                  :class="{ 'sub-selected': currentSubId === item.id }"
                  @click="switchSubtable(item.id)"
                >
                  <div>第{{ item.id + 1 }}天</div>
                </div>
              </div>
              <tr>
                <td colspan="2">行程项目</td>
                <td colspan="2">行程时间(分钟)</td>
                <td colspan="2">行程类型</td>
                <td>是否自费</td>
              </tr>
              <tr
                v-for="item in table[currentSubId].arrangement"
                :key="item.PointId"
              >
                <td colspan="2">{{ item.Projects }}</td>
                <td colspan="2">{{ item.TimeSpan }}</td>
                <td colspan="2">{{ item.PointType }}</td>
                <td>{{ item.IsSelf == false ? "否" : "是" }}</td>
              </tr>
              <tr v-if="detail.RemarkTrip&&detail.RemarkTrip!=''&&detail.RemarkTrip!=undefined&&detail.RemarkTrip.length > 0">
                <td colspan="2">备注行程</td>
                <td colspan="4">{{detail.RemarkTrip}}(分钟)</td>
              </tr>
              <tr v-for="(item, index) in model.guides" :key="index + 999">
                <td>导游</td>
                <td>{{ item.Name }}</td>
                <td>导游证</td>
                <td>{{ item.IDNumber }}</td>
                <td colspan="2">联系方式</td>
                <td>{{ item.Tel }}</td>
              </tr>

              <tr style="height:45px;">
                <td>是否是自备车</td>
                <td colspan="6">
                  <el-radio v-model="detail.IsSelf" label="0" border disabled>否</el-radio>
                  <el-radio v-model="detail.IsSelf" label="1" border disabled>是</el-radio>
                </td>
              </tr>
              <tr v-show="detail.IsSelf==='0'" v-for="(item, index) in model.drivers" :key="index + 888">
                <td>司机</td>
                <td>{{ item.Name }}</td>
                <td>车牌号</td>
                <td>{{ model.buses[index].PlateNumber }}</td>
                <td colspan="2">联系方式</td>
                <td>{{ item.Tel }}</td>
              </tr>
              <tr v-show="detail.IsSelf==='1'" v-for="(item,index) in model.selfBus" :key="index+555">
                <td>司机</td>
                <td>{{item.selfDriverName}}</td>
                <td>车牌号</td>
                <td>{{item.selfPlateNumber}}</td>
                <td colspan="2">联系方式</td>
                <td>{{item.selfDriverTel}}</td>
              </tr>
              <tr>
                <td :rowspan="visitors.length + 2">游客信息</td>
                <td>游客姓名</td>
                <td>人数（人）</td>
                <td style="min-width: 100px">手机号</td>
                <td colspan="2">身份证</td>
                <td>电子合同</td>
              </tr>
              <tr v-for="(item, index) in visitors" :key="index + 222">
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.Name }}
                  </p>
                </td>
                <td>
                  <p>{{ item.TotoalCount }}</p>
                </td>
                <td>
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ (visitor.Tel=="" || visitor.Tel==null )?"无":visitor.Tel }}
                  </p>
                </td>
                <td colspan="2">
                  <p v-for="visitor in item.AllTourist" :key="visitor.Id" style="line-height: 30px">
                    {{ visitor.IDNumber }}
                  </p>
                </td>
                <td>
                  <i
                    class="el-icon-s-order mouse-pointer"
                    @click="openContract(item.Id)"
                  ></i>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
      </div>
    </div>

    <el-dialog :visible.sync="contractDialog"  >
      <contract-detail
        :orderId="orderId"
        v-if="contractDialog"
      ></contract-detail>

      <div class="btn">
        <el-button @click="contractDialog = false"
          ><a style="color: #000">取 消</a></el-button
        >
        <el-button v-if="contractInfo.ContactAttachment"
          ><a
            :href="
              '/api/co/Order/DownLoadOneDayContact?orderId=' +
              contractInfo.orderId +
              '&sessionId=' +
              sessionId
            "
            style="color: #000"
            >下载合同</a
          ></el-button
        >
      </div>

    </el-dialog>

  </div>
</template>

<script>
import { getCookie } from "@/common/auth";
import { keyToVal, dateFormat,dateFormatTemp } from "@/filters/filters";
import ContractDetail from "@/components/Contract.vue";
import { mapState } from "vuex";
import Trip from "@/api/trip";
import Order from "@/api/order";
export default {
  name: "TicketManage",
  data() {
    return {
      contractInfo: {},
      sessionId: "",

      query: {
        Code: "",
        StartTime: "",
        EndTime: "",
        PageSize: 10,
        PageIndex: 1,
      },
      flag: 0,
      contractDialog: false,
      orderId: "",
      detail: {
      },
      visitors: [
        {
          Id: "",
          Name: "",
          TotoalCount: "",
          Tel: "",
          IDNumber: "",
          OrderId: "",
        },
      ],
      currentSubId: 0,
      table: [
        {
          id: 0,
          arrangement: [],
        },
      ],
      model: {
        guides: [],
        drivers: [],
        buses: [],
        selfBus:[],
      },
      tableData: [
      ],

      pagination: {
        total: 0,
        PageSize: 10,
        PageIndex: 1,
      },
       loadintTable:false,
      loadingLook:false,
    };
  },
  inject: ["deepClone"],
  components: {
    ContractDetail,
  },
  filters: {
    keyToVal,
    dateFormat,
    dateFormatTemp,
    getProjectType(value, projects) {
      for (const pro of projects) {
        if (pro.Id == value) {
          return pro.Type;
        }
      }
      return "";
    },
    getGuideCode(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.IDNumber;
        }
      }
      return "";
    },
    getGuideTel(value, guides) {
      for (const guide of guides) {
        if (guide.Id == value) {
          return guide.Tel;
        }
      }
      return "";
    },
    getDriverTel(value, drivers) {
      for (const driver of drivers) {
        if (driver.Id == value) {
          return driver.Tel;
        }
      }
      return "";
    },
  },
  computed: {
    ...mapState("trip", {
      options: (state) => {
        return {
          projects: state.projects,
        };
      },
    }),
    ...mapState("user", ["storeInfo"]),
    ...mapState("common", ["ticketStatus", "statusType"]),
  },
  methods: {
    GetData(orderId) {
      var _self = this;
      Order.getContractData({ Id: orderId }).then((res) => {
        if (res.status === "success") {
          _self.contractInfo = res.content;
        } else {
          _self.$message.error("合同获取失败!");
        }
      });
    },
    resetForm(formName){
      if (formName === "queryForm") {
        this.query = {
         Code: "",
          StartTime: "",
          EndTime: "",
          PageSize: 10,
          PageIndex: 1,
        };
      }
      this.getTickets();
    },
    openContract(orderId) {
      this.orderId = orderId;
      this.contractDialog = true;

      this.GetData(this.orderId);
    },
    //行程单列表
    getTickets() {
      this.query.PageSize = this.pagination.PageSize;
      this.query.PageIndex = this.pagination.PageIndex;
      this.loadintTable=true;
      Trip.loadItinerariesHistory(this.query).then((res) => {
        if (res.status === "success") {
          this.pagination.total = res.content.Total;
          this.tableData = res.content.OnePageData;
        } else {
          this.$message.error("列表获取失败!");
        }
        this.loadintTable=false;
      });
    },
    //行程单详情
    getDetail(row) {
      //清除信息
      this.model={
        guides: [],
        drivers: [],
        buses: [],
        selfBus:[],
      };
      this.detail.Id = row.Id;
      this.setTripInfo(row.Id);
    },
    //设置路线详情
    setTripInfo(Id) {
      var _self=this;
      _self.loadingLook=true;
      Trip.getTripDetail({ Id }).then((res) => {
        if (res.status === "success") {
          if (res.content.trip === null) {
            _self.$message.error("获取详情失败!");
            return false;
          }
          _self.detail = res.content.trip;
          _self.detail.ItinerariesId = res.content.trip.Id;
          if (
            Array.isArray(res.content.router) &&
            res.content.router.length > 0
          ) {
            _self.table = res.content.router.map((v, i) => {
              return {
                id: i,
                arrangement: v.router.map((a) => {
                  return {
                    PointId: a.PointId, //项目Id
                    DayIndex: a.DayIndex,
                    Time: [a.StartTime, a.EndTime],
                    IsSelf: a.IsZiFei,
                    PointType: a.PointType, //项目类型
                    Projects: a.Projects, //项目名称
                    TimeSpan:a.TimeSpan,//显示分钟
                  };
                }),
              };
            });
          }
           
          _self.model.guides = res.content.guide;
          _self.model.buses = res.content.bus;
          _self.model.drivers = res.content.driver;

          if(res.content.selfBus!=null && res.content.selfBus.length>0){
            _self.model.selfBus=res.content.selfBus.map((v)=>{
              return{
                selfDriverName:v.selfDriverName,
                selfPlateNumber:v.selfPlateNumber,
                selfDriverTel:v.selfDriverTel
              }
            });

            _self.model.drivers=[];
            _self.model.buses=[];
            _self.model.drivers.push({ Id: "" });
            _self.model.buses.push({ Id: "" });
          }
          else{
            _self.model.selfBus=[];
            _self.model.selfBus.push({selfDriverName:'',selfPlateNumber:'',selfDriverTel:''});
          }

          _self.visitors = res.content.newTourist;
          _self.flag = 1;
        } else {
          _self.$message.error("信息获取失败!");
        }
        _self.loadingLook=false;
      });
    },
    //子表操作
    switchSubtable(subId) {
      this.currentSubId = subId;
    },

    handlePageSize(value) {
      this.pagination.PageSize = value;
    },
    handlePageIndex(value) {
      this.pagination.PageIndex = value;
    },

  },
  created() {
    this.getTickets();
  },
  watch: {
    "pagination.PageSize": function () {
      this.getTickets();
    },
    "pagination.PageIndex": function () {
      this.getTickets();
    },

  },
   mounted() {
    this.sessionId = getCookie("sessionId");
  },
};
</script>


<style scoped lang="less">
.main-left {
  width: 40%;
  min-width: 620px;
  border-right: 1px solid #ddd;
}
.main-left .left-table {
  height: 753px;
  background: chocolate;
}
.main-left .left-pagination {
  height: 40px;
  background: #dedede;
  text-align: center;
}
.left-pagination .pagination-bottom {
  position: relative;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-right {
  flex: 1;
}
.right-table {
  padding: 20px;
}
.input-form {
  position: relative;
  width: 95%;
  min-width: 1310px;
  border-collapse: collapse;
  border: 1px solid #aaa;
  thead {
    // width: 100%;
    background-color: #f1f1f1;
    border: 1px solid #aaa;
  }
  th,
  tr {
    height: 33px;
    border: 1px solid #aaa;
  }
  td,
  th {
    text-align: center;
    vertical-align: middle;
    border: 1px solid #aaa;
  }
}
.input-form /deep/ .el-input__inner,
.input-form /deep/ .el-input-number,
.input-form /deep/ .el-select {
  border: none;
  width: 100%;
}
.input-form /deep/ .el-date-editor .el-range-input,
.input-form /deep/ .el-date-editor .el-range-separator {
  margin: 4px;
}
.addItem /deep/ .el-button {
  width: 100%;
}
.sub-selected {
  background: cornflowerblue;
}
.subtable-tab {
  position: absolute;
  top: 190px;
  left: 0;
  width: 100%;
  height: 45px;
  overflow: auto hidden;
  border-left: 1px solid #aaa;
  border-right: 1px solid #aaa;
  display: flex;
  // background: red;
}
.subtable-tab .tab-item {
  border-right: 1px solid #aaa;
  min-width: 60px;
  height: 45px;
  line-height: 45px;
  text-align: center;
}
.emphasis {
  font-weight: bolder;
}
</style>
